import React from 'react';

import styled from 'styled-components';

import Money from './Money';

const TotalsContainer = styled.div`
    margin: 0.75rem 0 0 auto;
    background: white;
    border: ${(props) => props.theme.DefaultBorder};
    border-top: 2px solid ${(props) => props.theme.PrimaryColor};
    display: flex;
    align-items: flex-start;
    gap: 3rem;
    padding: 0.75rem 2rem;
    width: fit-content;
    max-width: 100%;

    .grouped-currency-totals-label {
        text-transform: uppercase;
        font-size: ${(props) => props.theme.FontSizeMd};
        font-weight: bold;
        line-height: 1.3;
        padding-top: 0.05rem;
    }

    .grouped-currency-totals-amounts {
        text-align: right;
        line-height: 1.3;
    }

    @media only screen and (max-width: 920px) {
        width: 100%;
        justify-content: space-between;

        .grouped-currency-totals-amounts {
            text-align: right;
        }
    }
`;

const GroupedCurrencyTotalsBox = ({ totals, label = 'TOTALS', redIfNegative = true }) => {
    if (!totals || totals.length === 0) {
        return null;
    }

    return (
        <TotalsContainer>
            <div className="grouped-currency-totals-label">{label}</div>
            <div className="grouped-currency-totals-amounts">
                {totals.map((item) => (
                    <Money
                        key={item.Currency}
                        dineroObj={item.Dinero}
                        redIfNegative={redIfNegative}
                        boldIfDefaultCurrency
                        style={{ display: 'block', textAlign: 'inherit' }}
                    />
                ))}
            </div>
        </TotalsContainer>
    );
};

export default GroupedCurrencyTotalsBox;
